/* GS+ member price - updates on variant change */
(function () {
  if (customElements.get('gs-member-price')) return;

  class GsMemberPrice extends HTMLElement {
    connectedCallback() {
      var self = this;
      var jsonEl = this.querySelector('script[type="application/json"][data-gs-prices]');
      this.prices = {};
      if (jsonEl) {
        try {
          this.prices = JSON.parse(jsonEl.textContent || '{}');
        } catch (e) {
          this.prices = {};
        }
      }
      this.valueEl = this.querySelector('.gs-member-value');

      this._onVariantChanged = function (event) {
        self.onVariantChanged(event);
      };
      this._onIdChange = function () {
        self.onIdChange();
      };
      this._onDocEvent = function (event) {
        self.onDocEvent(event);
      };

      var formId = this.getAttribute('form');
      this._form = null;
      if (formId) {
        this._form = document.getElementById(formId) || document.forms[formId] || null;
      }

      this._idInput = null;
      if (this._form) {
        this._form.addEventListener('variant:change', this._onVariantChanged);
        this._idInput = this._form.querySelector('[name="id"]');
        if (this._idInput) {
          this._idInput.addEventListener('change', this._onIdChange);
        }
      }

      document.addEventListener('variant:change', this._onDocEvent, true);

      if (this._idInput && this._idInput.value) {
        this.applyPrice(this._idInput.value);
      }
    }

    disconnectedCallback() {
      if (this._form) {
        this._form.removeEventListener('variant:change', this._onVariantChanged);
      }
      if (this._idInput) {
        this._idInput.removeEventListener('change', this._onIdChange);
      }
      document.removeEventListener('variant:change', this._onDocEvent, true);
    }

    onDocEvent(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      if (this._form && event.target !== this._form && !this._form.contains(event.target)) {
        return;
      }
      this.applyPrice(variant.id);
    }

    onVariantChanged(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) {
        this.hidden = true;
        return;
      }
      this.applyPrice(variant.id);
    }

    onIdChange() {
      if (this._idInput && this._idInput.value) {
        this.applyPrice(this._idInput.value);
      }
    }

    applyPrice(id) {
      var price = this.prices[String(id)] || '';
      if (price) {
        this.hidden = false;
        if (this.valueEl) this.valueEl.textContent = price;
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('gs-member-price', GsMemberPrice);
})();
